export default __webpack_public_path__ + "static/media/IBMCAD.c2eb8067.svg";